import React, { useState } from 'react';
import { Modal } from '@ui-library/modalV2';
import { PasswordInput } from '@ui-library/input';

type usePasswordPromptOptions = {
  title?: string;
  onSubmit: (password: string) => void;
};

export function usePasswordPrompt({
  title = 'Enter your password',
  onSubmit,
}: usePasswordPromptOptions) {
  const [isVisible, setIsVisible] = useState(false);
  const [password, setPassword] = useState('');

  const toggleShow = () => {
    setPassword('');
    setIsVisible((prev) => !prev);
  };

  const handleOk = () => {
    onSubmit(password);
    toggleShow();
  };

  const modalPlaceholder = (
    <Modal
      title={title}
      open={isVisible}
      onOk={handleOk}
      onCancel={toggleShow}
      okText="Submit"
      cancelText="Cancel"
      destroyOnClose
    >
      <PasswordInput
        placeholder="Enter your password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onPressEnter={handleOk}
      />
    </Modal>
  );

  return { modalPlaceholder, toggleShow };
}
